import BaseUISystem from '../BaseUISystem';
import { PopupID } from '../../../State/UI/PopupID';
import BaseMenu from 'System/UI/Menu/BaseMenu';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { GameObjectEvent } from 'GameObject/GameObject';
import { UIActions } from 'State/UI/UIActions';
import {GameActions} from "State/Game/GameActions";
import { createEventOfferTimer, getActiveEventLayout, getEventOfferProductId } from 'State/Events/EventHelper';
import { ChristmasOfferLayout } from 'Layouts/Events/xmas_2021/eventOfferPopup/ChristmasOfferLayout';
import { ContextType } from 'State/Game/ContextType';
import { EventType } from 'Utility/Helpers/Events/EventType';
import { IAPHelper } from 'Utility/Helpers/IAP/IAPHelper';
import Game from 'Game';
import Timer from 'System/Timer/Timers/Timer';
import TextComponent from 'Component/Render/Text';
import { PlayerActions } from 'State/Player/PlayerActions';
import LevelHelper from 'Utility/LevelHelper';
import { formatStrikePrice, parseCurrency } from 'Utility/Currency';
import { IAPReward } from "Utility/RewardHelper";

interface IEventOfferShowParams {
    eventType: EventType;
}

export class EventOfferHandler extends BaseMenu {
    private layout: any;
    private timer: Timer;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.EVENT_OFFER, uiSystem, false);
    }

    public async preload() {
        this.resources.set('IAPRewards', `resource/data/rewards/IAPRewards.json`);
        await super.preload();
    }

    protected onCreate(): void {
        super.onCreate();
        this.layout = getActiveEventLayout(PopupID.EVENT_OFFER) || ChristmasOfferLayout;
    }

    public onShow(params: IEventOfferShowParams): void {
        super.onShow(params);


        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        const { closeButton, buyButton, timeText } = this.layout;

        [closeButton, buyButton].forEach(o => applyDefaultButtonAnimation(o));
        this.addListener(closeButton, GameObjectEvent.SELECTED, () => UIActions.hidePopup(this.name), { once: true });
        this.addListener(buyButton, GameObjectEvent.SELECTED, () => PlayerActions.attemptEventOfferPurchase({
            eventType: params.eventType,
            popupId: this.name
        }));

        const timerTextComponent = timeText.getComponent(TextComponent);
        this.timer = createEventOfferTimer(Game.store.getState(), params.eventType, timerTextComponent, {
            onComplete: () => {
                UIActions.hidePopup(this.name);
            }
        });

        this.timer.start();

        this.cleanupManager.add(() => {
            this.timer.stop();
        });

        const productId = getEventOfferProductId(params.eventType);
        const product = Game.sdk.getCatalog().products.find((e) => e.productId === productId);

        const IAPData = Game.resource.get('IAPRewards') as IAPReward[];

        const iapReward = IAPData.find(reward => reward.id === productId);

        const { beforeValue, value, afterValue } = parseCurrency(product.price);

        const language = Game.sdk.getLanguage();
        const fullCostStr = value.toLocaleString(language, { maximumFractionDigits: 2, minimumFractionDigits: 2 });

        this.layout.priceText.getComponent(TextComponent).text = `${beforeValue}${fullCostStr}${afterValue}`;

        const levelCostFactor = LevelHelper.getLevelCost(Game.player.getHighestLevelCompleted()) / 1000;
        const strikePriceUsd = iapReward.usdPriceWithoutDiscount * levelCostFactor;
        const strikePrice = formatStrikePrice({
            price: product.price,
            priceUsd: iapReward.usdPrice,
            strikePriceUsd,
        });

        this.layout.oldPrice.getComponent(TextComponent).text = strikePrice;
    }

    private addListener(obj: GameObject, event: string, action: () => any, options?: {
        once?: boolean
    }) {
        if (options?.once) {
            obj.once(event, action);
        }
        else {
            obj.on(event, action);
        }
        this.cleanupManager.add(() => {obj.off(event, action)});
    }


}
